import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SourceOfDeadlineBadgeComponent } from './source-of-deadline-badge.component';

@NgModule({
  declarations: [
    SourceOfDeadlineBadgeComponent,
  ],
  exports: [
    SourceOfDeadlineBadgeComponent,
  ],
  imports: [
    CommonModule,
  ],
})
export class SourceOfDeadlineBadgeModule { }
